import { MagnifyingGlassIcon } from '@phosphor-icons/react';

import { useLayoutStore } from '@/stores/layout-store';

const isMac = typeof navigator !== 'undefined' && navigator.platform.toUpperCase().includes('MAC');
const shortcutLabel = isMac ? '⌘K' : 'Ctrl K';

/** Readonly search trigger — opens the spotlight/command palette. */
export function SidebarSearch() {
  const openSearch = useLayoutStore((s) => s.openSearch);

  return (
    <button
      type="button"
      onClick={openSearch}
      className="flex items-center gap-2 h-8 px-2.5 rounded-lg w-full bg-sunken border border-line-subtle transition-colors hover:bg-surface-3 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring cursor-pointer"
    >
      <MagnifyingGlassIcon size={14} className="text-fg-tertiary shrink-0" />
      <span className="text-xs text-fg-tertiary truncate flex-1 text-left">Search or ask Atlas…</span>
      <span className="text-2xs font-medium text-fg-tertiary bg-surface-3 px-1.5 py-0.5 rounded leading-none">
        {shortcutLabel}
      </span>
    </button>
  );
}
